<template>
    <main class="layout__main--narrow layout__main--no-top-padding">
        <BaseHeader
            v-if="!notFound"
            :placeholder="pending"
            class="header--narrow"
        >
            <template #back>
                <BaseBackButton to="/guidelines/archive">
                    Guidelines archive
                </BaseBackButton>
            </template>

            <template v-if="guideline">
                <h1>Archive of the {{ guideline.title }} guideline</h1>
            </template>
            <h1 v-else><ContentPlaceholdersHeading /></h1>
        </BaseHeader>

        <BaseSection v-if="!notFound">
            <BaseAccordion
                v-if="!pending && guideline && guideline.archive"
                :items="guideline.archive"
            >
                <template #title="{ item }">
                    {{ item.year }}
                </template>

                <template #default="{ item }">
                    <BaseFileList
                        v-if="!pending"
                        :files="item.files"
                    />
                </template>
            </BaseAccordion>

            <ContentPlaceholders v-else>
                <ContentPlaceholdersHeading
                    v-for="i in [1,2,3,4,5]"
                    :key="i"
                />
            </ContentPlaceholders>
        </BaseSection>

        <BaseError
            v-else
            :error="error || { statusCode: 404 }"
        />
    </main>
</template>

<script setup>
import GuidelineArchiveQuery from '~/graphql/queries/guidelines/singleArchive.graphql';

const { activeSite } = useMultisite();
const { variables } = useCraftGraphqlSlug();

if (activeSite.value?.handle) {
    variables.site = activeSite.value?.handle;
}

const response = await useLazyAsyncQuery({
    query: GuidelineArchiveQuery,
    variables,
});

const {
    craftEntry: guideline,
    pending,
    error
} = usePageQuery(
    response,
    { entryKey: 'guideline', activeSite }
);


// seo.title = `Archive of the ${this.guideline?.title} guideline - Uroweb`;
</script>
